module.exports = __webpack_public_path__ + "media/images/redesign-images/home/collegiate-logos/iowa-state-university-508308afffa04abcbe28aa700fde3e6a.svg";